import { type PropsWithChildren, useContext } from 'react';

import './VendorLeadStepLayout.scss';

import LogoText from 'src/assets/logo-text.svg?react';
import { VendorLeadGuideMobile } from 'src/components/vendors/steps/VendorLeadGuideMobile';
import { VendorLeadStepGuide } from 'src/components/vendors/steps/VendorLeadStepGuide';
import { VendorLeadStepLayoutBackButton } from 'src/components/vendors/steps/VendorLeadStepLayoutBackButton';
import { VendorLeadStepLayoutNextButton } from 'src/components/vendors/steps/VendorLeadStepLayoutNextButton';
import { VendorLeadStepper } from 'src/components/vendors/steps/VendorLeadStepper';
import { VendorsContext } from 'src/pages/VendorsPage/VendorsPage.context';
import { VendorPageStep } from 'src/pages/VendorsPage/VendorsPage.context.types';

export function VendorLeadStepLayout({ children }: Readonly<PropsWithChildren>) {
  const { vendorStep } = useContext(VendorsContext);

  const canGoBack = vendorStep !== VendorPageStep.Pictures; // Ignore VendorPageStep.Start

  return (
    <div className="vendor-lead-step__layout">
      <div className="vendor-lead-step__layout__left" />

      <div className="vendor-lead-step__layout__center__header__backdrop" />
      <div className="vendor-lead-step__layout__center__header__container">
        <div className="vendor-lead-step__layout__center__header">
          <div className="vendor-lead-step__layout__center__header__left-buttons">
            {canGoBack && <VendorLeadStepLayoutBackButton />}
          </div>

          <div className="vendor-lead-step__layout__center__header__logo">
            <LogoText className="vendor-lead-step__layout__center__header__logo-text" />
            <div className="vendor-lead-step__layout__center__header__logo-icon" />
          </div>

          <div className="vendor-lead-step__layout__center__header__right-buttons">
            <VendorLeadGuideMobile />
          </div>
        </div>

        <div className="vendor-lead-step__layout__center__stepper">
          <VendorLeadStepper />
        </div>
      </div>

      <div className="vendor-lead-step__layout__center">
        <div className="vendor-lead-step__layout__center__content">{children}</div>

        {vendorStep !== VendorPageStep.Contact && (
          <div className="vendor-lead-step__layout__center__footer-actions">
            <VendorLeadStepLayoutNextButton />
          </div>
        )}
      </div>
      <div className="vendor-lead-step__layout__right">
        <VendorLeadStepGuide />
      </div>
    </div>
  );
}
